import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastNotification, ModalState, ModalType, UIState, EditFieldModalData } from '../../types';

const initialModalState: ModalState = {
  isOpen: false,
  modalType: 'none',
  headerText: '',
  bodyText: '',
  confirmText: '',
  cancelText: '',
  large: false,
  data: undefined,
  editFieldData: undefined,
};

const initialState: UIState = {
  toast: null,
  modal: initialModalState,
  pdfInputEmail: '',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    // Toast Actions
    showToast: (state, action: PayloadAction<ToastNotification>) => {
      state.toast = action.payload;
    },
    hideToast: (state) => {
      state.toast = null;
    },

    // Modal Actions
    openModal: (
      state,
      action: PayloadAction<{
        modalType: ModalType;
        headerText?: string;
        bodyText?: string;
        confirmText?: string;
        cancelText?: string;
        large?: boolean;
        data?: Record<string, unknown>;
        editFieldData?: EditFieldModalData;
      }>
    ) => {
      state.modal = {
        ...action.payload,
        isOpen: true,
      };
    },
    closeModal: (state) => {
      state.modal = initialModalState;
    },

    // PDF Email
    setPdfInputEmail: (state, action: PayloadAction<string>) => {
      state.pdfInputEmail = action.payload;
    },

    // Reset UI State
    resetUI: () => initialState,
  },
});

export const { showToast, hideToast, openModal, closeModal, setPdfInputEmail, resetUI } =
  uiSlice.actions;

export default uiSlice.reducer;
